import { render, staticRenderFns } from "./penilaian.vue?vue&type=template&id=b441e388&scoped=true"
import script from "./penilaian.vue?vue&type=script&lang=js"
export * from "./penilaian.vue?vue&type=script&lang=js"
import style0 from "./penilaian.vue?vue&type=style&index=0&id=b441e388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b441e388",
  null
  
)

export default component.exports